import { useContext } from 'react'

import { JourneyContext } from '@/contexts/journey'
import { Module } from '@/types/module'

interface UseModuleProps {
  currentModule: Module | undefined
  updateModule: (module: Module) => void
}

export const useModule = (): UseModuleProps => {
  const { currentModule, setCurrentModule } = useContext(JourneyContext)

  const updateModule = (module: Module) => {
    setCurrentModule(module)
  }

  return {
    currentModule,
    updateModule
  }
}
